"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { captureUtms } from "@/lib/utmUtils";

export default function UtmCaptureHandler() {
  const searchParams = useSearchParams();

  useEffect(() => {
    console.log("useEffect in UtmCaptureHandler running");
    const queryString = searchParams.toString();
    console.log("UtmCaptureHandler searchParams.toString():", queryString);
    captureUtms(queryString ? `?${queryString}` : "");
  }, [searchParams]);

  return null; // This component doesn't render anything visible
} 